import * as Sentry from '@sentry/react';
import packageJson from '../../../package.json';

export const SENTRY_RELEASE_VERSION = packageJson.version;

export function initAppErrorLogger(): void {
    if (import.meta.env.DEV) return;
    Sentry.init({
        dsn: 'https://e6eb6943ddf105f80f928b1289b2e89d@o4508448595247104.ingest.de.sentry.io/4508452441948240',
        release: SENTRY_RELEASE_VERSION,
        environment: window.location.hostname,
        maxBreadcrumbs: 50,
        sendDefaultPii: true,
        integrations: [
            Sentry.captureConsoleIntegration({levels: ['warn', 'error']}),
            Sentry.httpClientIntegration(),
            Sentry.browserSessionIntegration(),
            Sentry.browserApiErrorsIntegration({
                setTimeout: true,
                setInterval: true,
                requestAnimationFrame: true,
                XMLHttpRequest: true,
                eventTarget: true,
            }),
        ],
    });
}
